<template>
    <div class="scope-switcher">
        <Button
            view="no-border"
            icon="ChevronLeft"
            :class="['scope-switcher__left', { '-first-item': isFirstItem }]"
            @click="previous"
        />
        <div class="scope-switcher__current-item">{{ currentItem.name }}</div>
        <Button
            view="no-border"
            icon="ChevronRight"
            :class="['scope-switcher__right', { '-last-item': isLastItem }]"
            @click="next"
        />
    </div>
</template>

<script setup>
import { computed, defineProps, defineModel } from 'vue';
import Icon from './Icon.vue';
import Button from './Button.vue';
const props = defineProps({
    items: Array
});
const emit = defineEmits(['change']);

const currentItem = defineModel();
const currentPos = computed(() =>
    props.items.findIndex((item) => currentItem.value.id === item.id)
);
const isFirstItem = computed(() => currentItem.value.id === props.items[0].id);
const isLastItem = computed(
    () => currentItem.value.id === props.items.at(-1).id
);
const previous = () => {
    currentItem.value = props.items[currentPos.value - 1];
    emit('change');
};
const next = () => {
    currentItem.value = props.items[currentPos.value + 1];
    emit('change');
};
</script>
<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-switcher {
    display: inline-flex;
    background-color: $card-background;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
    width: fit-content;
    user-select: none;

    &__right,
    &__left {
        color: $icons-mid-emphasis;
        cursor: pointer;

        &.-first-item,
        &.-last-item {
            display: none;
        }
    }

    &__current-item {
        color: $text-high-emphasis;
        @include fz-24;
    }
}

body[theme='dark'] .scope-switcher {
    background-color: $app-background;
}
</style>
